import {
  DEFAULT_FILL_OPACITY,
  DEFAULT_LINE_OPACITY,
  LAYERS,
  SOURCES,
  DOT_COLORS,
} from './map-constants';

export const boundaryLayer = {
  id: LAYERS.CITY_BOUNDARY_LINE,
  type: 'line',
  source: SOURCES.SHAPE_FILE,
  layout: {
    'line-join': 'round',
    'line-cap': 'round',
  },
  paint: {
    'line-color': '#000',
    'line-width': 2,
    'line-opacity': DEFAULT_FILL_OPACITY,
  },
};

export const zoningFillLayer = (i) => ({
  id: `${LAYERS.ZONING_FILE_FILL}_${i}`,
  type: 'fill',
  source: `SOURCES.ZONING_FILE_${i}`,
  layout: {},
  paint: {
    'fill-color': [
      'case',
      ['boolean', ['feature-state', 'selected'], false],
      '#FAAD14',
      '#8AB186',
    ],
    'fill-opacity': [
      'case',
      ['boolean', ['feature-state', 'hover'], false],
      0.25,
      ['boolean', ['feature-state', 'selected'], false],
      0.25,
      DEFAULT_FILL_OPACITY,
    ],
  },
});

export const zoningBoundaryLayer = (i) => ({
  id: `${LAYERS.ZONING_FILE_LINE}_${i}`,
  type: 'line',
  source: `${SOURCES.ZONING_FILE}_${i}`,
  layout: {
    'line-join': 'round',
    'line-cap': 'round',
  },
  paint: {
    'line-color': [
      'case',
      ['boolean', ['feature-state', 'selected'], false],
      '#FAAD14',
      '#8AB186',
    ],
    'line-width': 2,
    'line-opacity': [
      'case',
      ['boolean', ['feature-state', 'hover'], false],
      0.5,
      ['boolean', ['feature-state', 'selected'], false],
      0.5,
      DEFAULT_LINE_OPACITY,
    ],
  },
});

export const clusterLayer = {
  id: LAYERS.CLUSTER,
  type: 'circle',
  source: SOURCES.PROPERTY_LIST,
  filter: ['has', 'point_count'],
  paint: {
    // Use step expressions (https://docs.mapbox.com/mapbox-gl-js/style-spec/#expressions-step)
    // with steps to implement three types of circles:
    //   *  20px circles when point count is less than 20
    //  and the rules are like the above
    'circle-color': '#37A3BC',
    'circle-radius': 18,
    'circle-opacity': 1,
    'circle-stroke-color': '#ffffff',
    'circle-stroke-width': 2,
  },
};

export const propertyCountLayer = {
  id: LAYERS.PROPERTY_COUNT,
  type: 'symbol',
  source: SOURCES.PROPERTY_LIST,
  filter: ['has', 'point_count'],
  layout: {
    'text-field': '{point_count_abbreviated}',
    'text-size': 14,
  },
  paint: {
    'text-color': '#fff',
  },
};

/**
 * "displayPopupAndDoManyOtherThings" method of rendering this component
 * results in fields with values of "null" being converted to the string "null"
 */
const isShortTermRental = [
  'all',
  ['==', ['get', 'shortTermRental'], true],
  ['!=', ['get', 'shortTermRental'], 'null'],
];

// const isLongTermRental = ['==', ['get', 'propertyType'], 'ltr'];
// const isHotel = ['==', ['get', 'propertyType'], 'hotel'];
// const isOther = ['==', ['get', 'propertyType'], 'other'];

const isNotNullStringApn = ['!=', ['get', 'apn'], 'null'];
const isAPNTruthy = ['to-boolean', ['get', 'apn']];
const isValidAPN = ['all', isNotNullStringApn, isAPNTruthy];

const isNullStringApn = ['!', isNotNullStringApn];
const isAPNFalsey = ['!', isAPNTruthy];
const isInvalidAPN = ['any', isNullStringApn, isAPNFalsey];

const isLicensed = ['==', ['to-boolean', ['get', 'strLicense']], true];
const unLicensed = ['==', ['to-boolean', ['get', 'strLicense']], false];
const isLive = ['==', ['get', 'live'], true];

function getIdentifiedColorCases(displayUnlicensedPropertiesSeparately) {
  if (!displayUnlicensedPropertiesSeparately) {
    return [['all', isShortTermRental, isValidAPN], DOT_COLORS.isIdentified];
  }

  return [
    ['all', isShortTermRental, isValidAPN, isLicensed],
    DOT_COLORS.isLicensed,

    ['all', isShortTermRental, isValidAPN, unLicensed],
    DOT_COLORS.unLicensed,
  ];
}

export function getPropertyListLayer(displayUnlicensedPropertiesSeparately) {
  return {
    id: LAYERS.PROPERTY_LIST,
    type: 'circle',
    source: SOURCES.PROPERTY_LIST,
    paint: {
      // https://docs.mapbox.com/mapbox-gl-js/style-spec/#expressions-match
      // using a match expression
      // https://blog.mapbox.com/going-live-with-electoral-maps-a-guide-to-feature-state-b520e91a22d
      'circle-radius': [
        'case',
        ['==', ['to-boolean', ['feature-state', 'hover']], true],
        9,
        6,
      ],
      'circle-color': [
        'case',

        ...getIdentifiedColorCases(displayUnlicensedPropertiesSeparately),

        ['all', isShortTermRental, isInvalidAPN, isLive],
        DOT_COLORS.isLiveWithoutAPN,

        DOT_COLORS.fallback,
      ],
      'circle-opacity': 0.85,
      'circle-stroke-width': 2,
      'circle-stroke-color': '#fff',
      'circle-stroke-opacity': 1,
    },
  };
}
